import Http from "./HttpService";

import { DEFAULT_LIMIT, DEFAULT_OFFSET } from "../constants/pagination";

class RewardsService extends Http {
  BASE_URL = "/admins/rewards";

  getList(pagination = {}) {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

    return this.get(`${this.BASE_URL}`, {
      params: {
        limit,
        offset,
      },
    });
  }

  create(model) {
    return this.post(`${this.BASE_URL}`, model);
  }

  async getOne(id) {
    const { data } = await this.get(`${this.BASE_URL}/${id}`);
    if (!data.image) {
      return { data };
    }
    const initialFile = data.image;
    initialFile.preview = data.image.resizedImages
      ? data.image.resizedImages[Object.keys(data.image.resizedImages)[0]]
      : data.image.link;
    initialFile.size = null;

    let initialCompanyLogoFile = null;
    if (data.companyLogoImage) {
      initialCompanyLogoFile = data.companyLogoImage;
      initialCompanyLogoFile.preview = data.companyLogoImage.resizedImages
        ? data.companyLogoImage.resizedImages[Object.keys(data.companyLogoImage.resizedImages)[0]]
        : data.companyLogoImage.link;
      initialCompanyLogoFile.size = null;
    }

    return { data: { ...data, initialFile, initialCompanyLogoFile } };
  }

  update(id, model) {
    return this.put(`${this.BASE_URL}/${id}`, model);
  }

  remove(id) {
    return this.delete(`${this.BASE_URL}/${id}`);
  }

  addImageToReward(id, model) {
    return this.post(`${this.BASE_URL}/${id}/image`, model);
  }

  addCompanyLogoImageToReward(id, model) {
    return this.post(`${this.BASE_URL}/${id}/company-logo-image`, model);
  }
}

export default new RewardsService();
